import React, { type JSX } from 'react';
import buyArrowIcon from '@/assets/svg/static/buyarrow.svg';
import shareIcon from '@/assets/svg/static/share2.svg';
import styles from './ProductDetailBottomCta.module.css';
import type { ProductDetailBottomCtaProps } from './ProductDetailBottomCta.types';

export const ProductDetailBottomCta = React.memo(
  ({
    isAvailable,
    paymentStatus,
    onShareClick,
    onBuyClick,
  }: ProductDetailBottomCtaProps): JSX.Element => {
    const isProcessing =
      paymentStatus === 'creating_order' ||
      paymentStatus === 'awaiting_payment' ||
      paymentStatus === 'confirming_payment';

    return (
      <div className={styles.ctaContainer}>
        <button
          aria-label="Share product"
          className={styles.shareBtn}
          onClick={onShareClick}
        >
          <img src={shareIcon} alt="Share" />
        </button>
        {isAvailable ? (
          <button
            className={styles.buyNowBtn}
            disabled={isProcessing}
            onClick={onBuyClick}
          >
            {isProcessing ? (
              <span>Processing...</span>
            ) : (
              <>
                <img src={buyArrowIcon} alt="" className={styles.buyIcon} />
                <span>Buy now</span>
              </>
            )}
          </button>
        ) : (
          <button disabled className={styles.outOfStockBtn}>
            Out of Stock
          </button>
        )}
      </div>
    );
  }
);

export default ProductDetailBottomCta;
